import { Component } from '@angular/core';
import { LoadingController, NavController } from 'ionic-angular';
import { Globals } from "../../../../globals";
import { DeliberyNoteCreateSelectProviderPage } from '../delibery-note-create-select-provider/delibery-note-create-select-provider';
import { DeliberyNoteCreateFotoPage } from '../delibery-note-create-foto/delibery-note-create-foto';
import { AddonsTriggerVersionProPage } from '../../../addons/addons-trigger-version-pro/addons-trigger-version-pro';

/**
 * Generated class for the DeliberyNoteCreateIngprodPricePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-delibery-note-create-type',
  templateUrl: 'delibery-note-create-type.html',
})
export class DeliberyNoteCreateTypePage {


  constructor(public navCtrl: NavController,
    public loadingCtrl: LoadingController,
    public globals: Globals,
  ) {
  }

  EntradaManual() {
    if (this.globals.checkLimitsByLicense('stock', 'delivery_notes')) {
      this.navCtrl.push(DeliberyNoteCreateSelectProviderPage);
    } else {
      this.navCtrl.push(AddonsTriggerVersionProPage);
    }
  }

  EntradaFoto() {
    if (this.globals.checkLimitsByLicense('stock', 'delivery_notes')) {
      this.navCtrl.push(DeliberyNoteCreateFotoPage)
    } else {
      this.navCtrl.push(AddonsTriggerVersionProPage);
    }
  }
}


// WEBPACK FOOTER //
// ./src/pages/delibery_note/delibery-note-create/delibery-note-create-type/delibery-note-create-type.ts